
import { BellRing } from 'lucide-react';
import type { AccountPreferences } from '@/lib/painel-account-settings';
import { AccountPreferenceRow, AccountSettingsCard } from './account-settings-shared';

type PreferencesCardProps = {
  preferences: AccountPreferences;
  onChange: (preferences: AccountPreferences) => void;
  delay?: number;
};

const PREFERENCE_ITEMS: {
  key: keyof AccountPreferences;
  title: string;
  description: string;
}[] = [
  {
    key: 'panelNotifications',
    title: 'Receber notificações do painel',
    description: 'Alertas sobre atividade geral, atualizações e avisos do sistema.',
  },
  {
    key: 'commentAlerts',
    title: 'Receber avisos de novos comentários',
    description: 'Quando alguém comentar em conteúdos que você segue ou criou.',
  },
  {
    key: 'emailNotifications',
    title: 'Receber notificações por e-mail',
    description: 'Resumo e alertas importantes enviados para seu e-mail cadastrado.',
  },
  {
    key: 'profileVisible',
    title: 'Mostrar meu perfil para outros administradores',
    description: 'Permite que outros membros vejam suas informações básicas no painel.',
  },
];

export function PreferencesCard({ preferences, onChange, delay = 0 }: PreferencesCardProps) {
  return (
    <AccountSettingsCard
      title="Preferências"
      description="Controle como e quando você deseja ser notificado."
      icon={BellRing}
      accentClass="bg-amber-500/15 text-amber-300 ring-amber-400/25"
      delay={delay}
    >
      <div className="space-y-3">
        {PREFERENCE_ITEMS.map((item) => (
          <AccountPreferenceRow
            key={item.key}
            id={`pref-${item.key}`}
            title={item.title}
            description={item.description}
            checked={preferences[item.key]}
            onCheckedChange={(checked) =>
              onChange({ ...preferences, [item.key]: checked })
            }
          />
        ))}
      </div>
    </AccountSettingsCard>
  );
}
